import keymirror from 'keymirror';

// eslint-disable-next-line import/prefer-default-export
export const roles = keymirror({
  admin: null,
  orgAdmin: null,
  employee: null,
});
